import {i18n} from '@/common/i18n';
import {hasActiveUploads} from '@/composables/fileSystem/uploadQueue';
import {confirm} from '@simpleforyou/client-alerts';

// T00TNZLQQPYX — leaving the app ends running uploads: closing or reloading the
// tab, opening a foreign page, or logging out (the token ends with the session).
// Navigation inside the app keeps them running and is not affected.

export function warnBeforeUnload(event: BeforeUnloadEvent): void {
  if (!hasActiveUploads.value) {
    return;
  }
  // Browsers show their own text; both calls are needed across browsers.
  event.preventDefault();
  event.returnValue = '';
}

// Asks before a manual logout while uploads run. Returns whether to go on.
export async function confirmLogoutWithUploads(): Promise<boolean> {
  if (!hasActiveUploads.value) {
    return true;
  }
  const t = i18n.global.t;
  const result = await confirm({
    title: t('fileSystem.upload.leave.title'),
    text: t('fileSystem.upload.leave.text'),
    tone: 'warning',
    confirmLabel: t('fileSystem.upload.leave.confirm'),
    cancelLabel: t('fileSystem.upload.leave.cancel'),
  });
  return result.status === 'confirmed';
}
